import React from 'react';
import useAuthProvider from 'Components/session/authProvider';
import useSession from 'Components/session/session';
export const loginHook = (Component)  => {
    return (props) => {
        const authProvider = useAuthProvider();
        const session = useSession();
        return <Component {...props} authProvider = {authProvider} session = {session} />;
    };
};